import { AlertTriangle, Loader2 } from 'lucide-react';
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export default function AlertDialogExitConfirmation({
    open,
    onOpenChange,
    onConfirm,
    onExitWithoutSave,
    isSaving = false,
    saveOnExit = false,
}) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-sm">
                <AlertDialogHeader className="items-center">
                    <div className="w-14 h-14 rounded-full bg-warning/10 flex items-center justify-center mb-2">
                        {isSaving ? (
                            <Loader2 className="w-6 h-6 text-warning animate-spin" />
                        ) : (
                            <AlertTriangle className="w-6 h-6 text-warning" />
                        )}
                    </div>
                    <AlertDialogTitle className="text-center text-lg">
                        {isSaving ? t('common:sauvegardeEnCours') : t('common:quitterLaProcedure')}
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-center text-sm">
                        {saveOnExit
                            ? t('common:voulezVousEnregistrerVotreProgressionAvantDeQuit')
                            : t('common:toutesVosDonneesSerontPerduesSiVousQuittez')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="flex-col gap-3 sm:flex-col">
                    {saveOnExit && (
                        <Button
                            variant="solid"
                            color="secondary"
                            size="xxl"
                            onClick={onConfirm}
                            disabled={isSaving}
                            className="w-full rounded-xl"
                        >
                            {isSaving ? t('common:sauvegarde') : t('common:enregistrerLeBrouillon')}
                        </Button>
                    )}
                    <Button
                        variant="solid"
                        color="destructive"
                        size="xxl"
                        onClick={saveOnExit ? onExitWithoutSave : onConfirm}
                        disabled={isSaving}
                        className="w-full rounded-xl"
                    >
                        {saveOnExit ? t('common:quitterSansEnregistrer') : t('common:ouiQuitter')}
                    </Button>
                    <AlertDialogCancel
                        variant="soft"
                        color="neutral"
                        className="w-full mt-0 rounded-xl py-3.5"
                        disabled={isSaving}
                    >
                        {t('common:annuler')}
                    </AlertDialogCancel>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
